// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__Bv71o","sendOtp":"AuthorizeToLogin_sendOtp__26TnB"};